<template>
  <section class="qv-card">
    <p class="qv-section-title">Dados da Última Compra</p>

    <template v-if="loading">
      <div class="qv-stat-row">
        <div class="qv-stat">
          <span class="qv-sk qv-sk-label"></span>
          <span class="qv-sk qv-sk-value"></span>
        </div>
        <div class="qv-stat">
          <span class="qv-sk qv-sk-label"></span>
          <span class="qv-sk qv-sk-value"></span>
          <span class="qv-sk qv-sk-sub"></span>
        </div>
        <div class="qv-stat">
          <span class="qv-sk qv-sk-label"></span>
          <span class="qv-sk qv-sk-value"></span>
        </div>
      </div>
      <div class="qv-stat-row">
        <div class="qv-stat" v-for="n in 3" :key="'r2-' + n">
          <span class="qv-sk qv-sk-label"></span>
          <span class="qv-sk qv-sk-value"></span>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="qv-stat-row">
        <div class="qv-stat">
          <span class="qs-label">Data</span>
          <span class="qs-value date-value">{{ display(formatDate(purchase.date)) }}</span>
        </div>

        <div class="qv-stat">
          <span class="qs-label">Quantidade</span>
          <span class="qs-value">
            {{ display(purchase.quantity) }}
            <span class="u">un</span>
          </span>
          <span class="qs-sub">{{ display(purchase.packages) }} emb. × {{ display(purchase.packageSize) }} un</span>
        </div>

        <div class="qv-stat">
          <span class="qs-label">Valor</span>
          <span class="qs-value">{{ display(formatCurrency(purchase.value)) }}</span>
        </div>
      </div>

      <div class="qv-stat-row">
        <div class="qv-stat">
          <span class="qs-label">Fornecedor</span>
          <span class="qs-value supplier-value">{{ display(purchase.supplier) }}</span>
        </div>

        <div class="qv-stat">
          <span class="qs-label">Vendas após compra</span>
          <span class="qs-value">
            {{ display(purchase.salesAfter) }}
            <span class="u">un</span>
          </span>
        </div>

        <div class="qv-stat">
          <span class="qs-label">Estoque Estimado (Saldo)</span>
          <span class="qs-value">
            {{ display(purchase.estimatedStock) }}
            <span class="u">un</span>
          </span>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
export default {
    name: 'QvLastPurchase',

    props: {
        lastPurchase: {
            type: Object,
            default: null,
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        purchase() {
            return this.lastPurchase || {};
        },
    },

    methods: {
        display(value) {
            return value === null || value === undefined || value === ''
                ? '—'
                : value;
        },

        formatDate(value) {
            if (!value) {
                return '';
            }

            const raw = String(value).substring(0, 10);
            const [year, month, day] = raw.split('-');

            if (!year || !month || !day) {
                return '';
            }

            return `${day}/${month}/${year}`;
        },

        formatCurrency(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }

            return Number(value).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import './_qv-shared.scss';
</style>
